import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetActiveSellersByLocationsOutput } from './GetActiveSellersByLocationsOutput';

export class GetActiveSellersByLocationsService extends HttpServiceBase {

  handle = (locations: string): Promise<Result<GetActiveSellersByLocationsOutput> | null> => {
    const promise = this.http.get<Result<GetActiveSellersByLocationsOutput>>(`${this.baseUrlSislogApi}/v2/seller/active-by-locations?locations=${locations}`);
    return promise;
  }
}